import { render, staticRenderFns } from "./CommissionPayment.vue?vue&type=template&id=2510986f"
import script from "./CommissionPayment.vue?vue&type=script&lang=js"
export * from "./CommissionPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports